import React, { Component } from "react";
import Accordion from "../partials/accordion/Accordion";

class StateGroningenDrenthe extends Component {
  render() {
    return (
      <div className="state-groningen-drenthe">
        <h1>De Staat van Groningen en Noord-Drenthe</h1>
        <p className="intro">
          In februari 2023 presenteerde de parlementaire enquêtecommissie
          aardgaswinning Groningen het rapport ‘Groningers boven gas’. De
          kabinetsreactie, ‘Nij Begun’, kwam in april 2023.
        </p>
        <p>
          Eén van de 50 maatregelen uit Nij Begun is het jaarlijks uitbrengen
          van de Staat van Groningen en Noord-Drenthe. De Staat volgt de
          voortgang van de uitvoering van de maatregelen en de effecten van het
          gevoerde beleid. De Staat van Groningen en Noord-Drenthe 2025 is een
          beknopte versie, omdat het enige tijd duurt voordat sommige
          maatregelen uit Nij Begun van kracht worden.
        </p>
        <a
          href="/files/staat-van-groningen-noord-drenthe-2025.pdf"
          className="button"
        >
          Download het rapport ‘De Staat van Groningen en Noord-Drenthe 2025’
        </a>
        <p className="note">
          Dit rapport is samengesteld door de onafhankelijke onderzoekers van
          CMO STAMM, Aletta Advies en KplusV, in opdracht van het Ministerie van
          Binnenlandse Zaken en Koninkrijksrelaties. Het ministerie heeft een
          beknopte selectie van het rapport gemaakt, die u hieronder kunt lezen.
        </p>

        <div className="content__block">
          <h2>Schadeafhandeling en herstel</h2>
          <p className="note__pages">Rapport pagina’s 6-21</p>
          <p>
            Het IMG (Instituut Mijnbouwschade Groningen) is verantwoordelijk
            voor de afhandeling van mijnbouwschade als gevolg van de gaswinning.
            Het IMG beoordeelt en vergoedt schade aan gebouwen. Daarnaast bieden
            ze regelingen voor waardedaling en immateriële schade, zoals stress
            en gezondheidsklachten door de aardbevingen.
          </p>
          <p>
            Het IMG en de voorganger TCMG hebben samen sinds 2018 in totaal meer
            dan € 2,5 miljard aan schadeherstel uitgekeerd vanuit alle
            regelingen. Het grootste deel daarvan is uitgekeerd aan vergoedingen
            voor fysieke schade, namelijk ruim € 1,6 miljard. Voor de regeling
            voor waardedaling is meer dan € 570 miljoen uitgekeerd en aan
            immateriële schade is inmiddels ruim € 260 miljoen uitgekeerd.
          </p>
          <p>
            In 2024 zijn voor de verschillende regelingen in totaal ruim 94.000
            aanvragen gedaan. Het totaal aantal schademeldingen voor alle
            regelingen sinds de oprichting van het IMG staat per 31 december op
            ruim 524.000. Van alle afgehandelde meldingen is 69,2% toegekend.
          </p>
          <img
            src="images/figuur_totaaloverzicht van alle regelingen (cumulatief op peildatum 31 december 2024).png"
            alt="
                Totaaloverzicht van alle regelingen (cumulatief op peildatum 31 december 2024).

                Alle regelingen 2020 t/m 2024: €2510895999.
                Meldingen: 524207.
                Afgehandeld: 501494.
                Toegekend: 347124 (69,2%).

                Fysiek: €1676949312.
                Meldingen: 268776.
                Afgehandeld: 249113.
                Toegekend: 189731 (76,2%).

                Waardedaling: €573661769.
                Meldingen: 123526.
                Afgehandeld: 123198.
                Toegekend: 87473 (71,0%).

                Immaterieel: €260284918.
                Meldingen: 131905.
                Afgehandeld: 129183.
                Toegekend: 69920 (54,1%).

                Aantal meldingen, afgehandeld en toegekend in 2024.

                Fysiek.
                Nieuwe meldingen: 43568.
                Afgehandeld: 47039.
                Toegekend: 36568.

                Waardedaling.
                Nieuwe meldingen: 3942.
                Afgehandeld: 3772.
                Toegekend: 1583.

                Immaterieel.
                Nieuwe meldingen: 46653.
                Afgehandeld: 46353.
                Toegekend: 21878.

                Totaal.
                Nieuwe meldingen: 94163.
                Afgehandeld: 97164.
                Toegekend: 60029.
                "
          />
        </div>

        <div className="content__block">
          <h2>Versterken</h2>
          <p className="note__pages">Rapport pagina’s 24-39</p>
          <p>
            Nationaal Coördinator Groningen (NCG) gaat over de
            veiligheidsbeoordeling van alle adressen in de versterkingsopgave.
            NCG zorgt waar nodig voor de versterking van gebouwen in het
            aardbevingsgebied. Ze laten onafhankelijke experts de woningen en
            overige gebouwen inspecteren. Op basis van deze externe onderzoeken
            versterkt NCG vervolgens de gebouwen die onveilig zijn.
          </p>
          <p>
            NCG werkt aan de versterking van in totaal 27.713 adressen (per
            datum 31 december 2024). De opdracht van NCG is al deze adressen ‘op
            norm’ te krijgen. Als een woning ‘op norm’ is, betekent dit dat het
            huis aan de landelijke veiligheidsnorm voldoet. Bewoners hebben dan
            minimaal een half uur de tijd om hun woning veilig te verlaten bij
            een zware beving. Woningen die niet voldoen aan deze veiligheidsnorm
            worden versterkt of, soms geheel of gedeeltelijk nieuw gebouwd.
          </p>
          <p>
            Om het versterkingsproces inzichtelijk te maken werkt NCG met 6
            fasen:
          </p>
          <ul>
            <li>
              Fase 1: Het adres is nog niet opgenomen in het plan van aanpak van
              de gemeente.
            </li>
            <li>
              Fase 2: Het adres is opgenomen in het plan van aanpak van de
              gemeente.
            </li>
            <li>
              Fase 3: De opname is uitgevoerd (onderzoeksgegevens zijn
              verzameld).
            </li>
            <li>
              Fase 4: Het adres is beoordeeld en niet op norm; (voorbereiden)
              opstellen van het uitvoeringsplan.
            </li>
            <li>Fase 5: De (voorbereiding van) de bouw is gestart.</li>
            <li>Fase 6: Het adres voldoen aan de veiligheidsnorm (veilig)</li>
          </ul>
          <Accordion
            title="Fase 1 en 2. Nog te starten & de opname en verzameling van gegevens"
            content={
              <div>
                <p>
                  Het doel voor 2024 was om voor de 877 resterende adressen de
                  opname uit te voeren. Uiteindelijk zijn er 423 adressen
                  opgenomen. 462 van de 27.713 adressen (1,7%) moeten nog worden
                  opgenomen.
                </p>
                <p>
                  De NCG schrijft in haar eindrapportage van december 2024 dat
                  voor ongeveer 300 adressen het uitvoeren een opname lastig is
                  omdat ze geen contact kan krijgen met de eigenaar, de eigenaar
                  niet mee wil werken aan de versterking, of de eigenaar de
                  versterking wil uitstellen. Daarnaast zijn er ongeveer 150
                  adressen uitgezet bij ingenieursbureaus, waarbij het voor een
                  deel om uitzonderingen gaat die maatwerk vragen.
                </p>
              </div>
            }
          />
          <Accordion
            title="Fase 3. Beoordeling"
            content={
              <p>
                Op 1 januari 2024 was er voor 4.521 adressen nog geen
                beoordelingsrapport. Ook hier geldt dat het voor sommige
                adressen lastig is contact te krijgen of dat de eigenaar uitstel
                wil. Uiteindelijk zijn er in 2024 4.158 beoordelingsrapporten
                vastgesteld. Daarnaast werden 889 herbeoordelingen vastgesteld.
                In totaal is de beoordeling voor 26.782 van de 27.713 adressen
                afgerond.
              </p>
            }
          />
          <Accordion
            title="Fase 4 en 5. Planvorming en versterken"
            content={
              <p>
                Er zitten 10.186 adressen in de plan- en versterkingsfasen. Voor
                2.915 woningen is de bouw gestart (11% in fase 5). Voor ongeveer
                de helft hiervan is de bouw in het jaar 2024 gestart (1.452).
                7.271 adressen zitten in de planvormingsfase (26%). Dat betekent
                dat deze groep een beoordeling heeft en weet dat de woning niet
                op norm is, maar nog werkt aan het plan om tot versterking over
                te gaan. In 2024 werd voor 1.586 adressen een uitvoeringsplan
                gestart en werd voor 1.530 adressen een uitvoeringsplan
                vastgesteld.
              </p>
            }
          />
          <Accordion
            title="Fase 6. Afgerond"
            content={
              <p>
                Eind 2023 zat 43% van alle adressen in fase 6, een jaar later op
                31 december 2024 geldt voor 60% van alle adressen dat de
                versterking is afgerond. Dat gaat om 16.596 adressen die voldoen
                aan de landelijke veiligheidsnorm. De doorlooptijd van het
                traject (opname tot en met afronding) varieert van een half jaar
                tot meerdere jaren.
              </p>
            }
          />
        </div>
        <img
          src="images/figuur_jaar op jaar versterking per fase.png"
          alt="
            2020 (N=26724): 6% in fase 6, 5% in fase 5, 34% in fase 4, 24% in fase 3, 19% in fase 2, 12% in fase 1.
            2021 (N=26958): 13% in fase 6, 5% in fase 5, 39% in fase 4, 25% in fase 3, 10% in fase 2, 8% in fase 1.
            2022 (N=27234): 30% in fase 6, 6% in fase 5, 37% in fase 4, 16% in fase 3, 10% in fase 2, <2% in fase 1.
            2023 (N=27455): 43% in fase 6, 9% in fase 5, 31% in fase 4, 13% in fase 3, 3% in fase 2, <2% in fase 1.
            2024 (N=27713): 60% in fase 6, 11% in fase 5, 28% in fase 4, 2% in fase 3, <2% in fase 2, <1% in fase 1.

            Fase 1: Het adres is nog niet opgenomen in het plan van aanpak van de gemeente.
            Fase 2: Het adres is opgenomen in het plan van aanpak van de gemeente.
            Fase 3: De opname is uitgevoerd (onderzoeksgegevens zijn verzameld).
            Fase 4: Het adres is beoordeeld en niet op norm; (voorbereiden) opstellen van het uitvoeringsplan.
            Fase 5: De (voorbereiding van) de bouw is gestart.
            Fase 6: Het adres voldoen aan de veiligheidsnorm (veilig).
            "
        />
        <div className="content__block">
          <h2>Staat van de kennis</h2>
          <p className="note__pages">Rapport pagina’s 44-51</p>
          <p>
            Kennis is van groot belang voor goed beleid. Onderzoek naar de
            gevolgen van de gaswinning gaat dan ook onverminderd door. Er
            verschenen 52 publicaties in 2024. De meeste publicaties gaan over
            de hersteloperatie en de beleving van schade en versterking.
            Gezondheid en welzijn blijven ook veelbesproken thema’s. Opvallend
            is dat er in 2024 voor het eerst expliciet aandacht is voor
            ondernemerschap. Er is ook één publicatie uitgekomen over jongeren
            en één over (Noord-)Drenthe.{" "}
            <a href="files/staat-van-groningen-noord-drenthe-2025.pdf">
              In het digitale rapport staan alle linkjes naar de publicaties.
            </a>
          </p>
        </div>

        <div className="content__block">
          <h2>Staat van de aanpak</h2>
          <p className="note__pages">Rapport pagina’s 56-65</p>
          <p>
            Naast maatregelen om de schadeherstel- en versterkingsoperatie
            milder, menselijker en makkelijker te maken, neemt het Rijk ook
            specifieke maatregelen gericht op het inlossen van de ereschuld en
            het bieden van perspectief. Samen werken het Rijk en de regio
            Groningen en Noord-Drenthe dit pakket aan maatregelen uit in een
            isolatieaanpak, een sociale agenda en een economische agenda.
          </p>

          <Accordion
            title="Isoleren en verduurzamen (maatregel 28 en 29)"
            content={
              <div>
                <p>
                  Maatregel 28 combineert zware- en middelzware versterkingen
                  van woningen met het isoleren ervan. Wanneer de bouwtijd van
                  de versterking minimaal 4 maanden duurt en de bewoners
                  langdurig niet thuis kunnen wonen, komen de bewoners in
                  aanmerking voor maatregel 28. Het doel is dat deze woningen na
                  één periode van verbouwing versterkt zijn en zijn voorbereid
                  op een toekomst zonder aardgas. NCG werkt samen met bewoners
                  die nog in de versterking zitten aan het vinden van een
                  passende oplossing per woning. Deelname aan de verduurzaming
                  is vrijwillig: bewoners beslissen zelf of ze er gebruik van
                  willen maken.
                </p>
                <p>
                  Maatregel 29 richt zich op het krijgen van een lagere
                  energierekening. Met maatregel 29 kunnen alle huiseigenaren in
                  het gebied in Groningen en Noord-Drenthe subsidie krijgen voor
                  het isoleren van woningen wanneer hun huis nog niet voldoet
                  aan de standaard voor woningisolatie. Deze ‘standaard’ geeft
                  aan of een huis voldoende geïsoleerd is om aardgasvrij te
                  kunnen verwarmen. Voor deze maatregel is een bedrag van € 1,65
                  miljard beschikbaar gesteld. Dat is ongeveer het dubbele van
                  wat elders in Nederland aan subsidie beschikbaar is. Naast het
                  verminderen van energiearmoede, gaat het ook om het verbeteren
                  van de leefomstandigheden en het verhogen van het wooncomfort.
                </p>
              </div>
            }
          />
          <Accordion
            title="De sociale agenda (maatregel 34)"
            content={
              <p>
                De sociale agenda is een belangrijk onderdeel van de
                kabinetsreactie, gericht op het bieden van nieuw perspectief en
                op het verbeteren van de brede welvaart in de regio. In totaal
                is er € 3,5 miljard te besteden gedurende 30 jaar. Dit geld
                wordt geïnvesteerd in het verbeteren van (mentale) gezondheid,
                de leefbaarheid, kansen voor kinderen en jongeren. Daarnaast
                wordt er gewerkt aan meer werk en minder armoede.{" "}
                <a href="https://www.rijksoverheid.nl/onderwerpen/herstel-gaswinning-groningen-en-noord-drenthe/nieuws/2025/01/23/sociale-agenda-voor-groningen-en-noord-drenthe-gepresenteerd">
                  De sociale agenda is op 23 januari 2025 gepresenteerd.
                </a>
              </p>
            }
          />
          <Accordion
            title="De concept economische agenda (maatregel 35)"
            content={
              <p>
                De regio heeft een economische impuls nodig. Er is een grote
                stap nodig om de regio duurzaam economisch te versterken. Voor
                de economische agenda is tot 2055 in totaal € 4,5 miljard
                beschikbaar. Het meeste daarvan, € 3,25 miljard, is bedoeld voor
                een investering van dertig jaar in sleutelprojecten voor de
                versterking van de economische structuur. De overige € 1,25
                miljard is bedoeld voor extra ondersteunende investeringen. Dit
                helpt om de agenda sneller uit te voeren en belangrijke
                randvoorwaarden te realiseren.{" "}
                <a href="https://www.rijksoverheid.nl/onderwerpen/herstel-gaswinning-groningen-en-noord-drenthe/nieuws/2025/03/06/economische-agenda-voor-groningen-en-noord-drenthe-gepresenteerd">
                  De economische agenda is op 6 maart 2025 gepresenteerd.
                </a>
              </p>
            }
          />
          <Accordion
            title="Vertrouwen en functioneren van de overheid (maatregel 36 t/m 50)"
            content={
              <div>
                <p>
                  Maatregel 36 t/m 50 uit Nij Begun gaan over het herstel van
                  vertrouwen in de overheid. Het vertrouwen in landelijke
                  instituties, zoals de Tweede Kamer, politie en rechters, is in
                  Groningen lager dan het landelijke gemiddelde. Volgens de
                  Brede Welvaart Monitor Groningen en Drenthe (2024) vertrouwt
                  58% van de Groningers deze instituties en 59% van de Drenten,
                  tegenover 61% landelijk. Binnen de provincies zijn er grote
                  verschillen: in de gemeente Groningen is het vertrouwen met
                  65% het hoogst, terwijl in Eemsdelta slechts 49% van de
                  inwoners vertrouwen heeft in deze instituties. In Drenthe
                  hebben inwoners van de gemeente Tynaarlo het meeste vertrouwen
                  in instituties (65%).
                </p>
                <p>
                  De optelsom van specifieke maatregelen en maatregelen binnen
                  versterking, schade, isolatieaanpak, sociale agenda en
                  economische agenda moet leiden tot herstel van vertrouwen. Het
                  kabinet wil het vertrouwen ook herstellen door in gesprek te
                  blijven met de inwoners van Groningen en Noord-Drenthe en door
                  concrete resultaten te laten zien. De Staat van Groningen en
                  Noord-Drenthe is hier een instrument voor.
                </p>
              </div>
            }
          />
          <a
            href="https://www.rijksoverheid.nl/ministeries/ministerie-van-binnenlandse-zaken-en-koninkrijksrelaties/evenementen/presentatie-staat-van-groningen-en-noord-drenthe"
            className="button__link"
          >
            Lees meer over de staat van Groningen en Noord-Drenthe.
          </a>
        </div>
      </div>
    );
  }
}

export default StateGroningenDrenthe;
